export const eventsData = [
  {
    id: 11,
    title: "Introduction to Prompt Engineering ",
    date: "2026-04-02T12:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1773830287/ai-academy/Image_zv2w4t.jpg",
    watchUrl:
      "https://drive.google.com/file/d/123kgkk-E5t2OGF19b33YAB8ZG9B_E8Nj/view?usp=sharing",
    speakers: [
      {
        name: "Oluwasegun Odusina",
        title: " AI/ML Engineer at Punch Group",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1773225384/ai-academy/Image_2_1_hqs5xs.jpg",
      },
    ],
  },
  {
    id: 12,
    title:
      "The Future of Work: How AI is Shaping Global Opportunities & Unlocking New Frontiers",
    date: "2026-03-26T13:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1773830286/ai-academy/Image_1_b1mp6u.jpg",
    watchUrl: "#",
    speakers: [
      {
        name: "Kevin Chumun",
        title: "Senior Vice President – Global Sales & Operations",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1773214456/ai-academy/Kevin_Headshot_ngunll.png",
      },
    ],
  },
  {
    id: 1,
    title: "Everything AI: Question and Answer Session",
    date: "2023-04-30T19:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1682698394/0a3e57df-2be2-4027-84f0-8ac7d6059674_qnbhgz.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1MAUZBDzkSM2I_LhokWva138dMs0HYfj4/view?usp=sharing",
    speakers: [
      {
        name: "David Edoja",
        title: "CEO, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362548/David_Edoja2_-_AI_ybv7dm.png",
      },
      {
        name: "Samuel Emmanuel",
        title: "Data Scientist, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1682754505/sam-headshot_q8kzmu.jpg",
      },
    ],
  },
  {
    id: 2,
    title: "Artificial Intelligence in Africa: The Key Concerns",
    date: "2023-04-18T14:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1681991182/newcentral_dkmyia.jpg",
    watchUrl: "https://youtu.be/0_2um4s6oMc",
    speakers: [
      {
        name: "Kemini Amanor",
        title: "Host - News Central",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1682000240/Keminni_mstxdf.jpg",
      },
      {
        name: "Malik Afegbua",
        title: "CEO - Slickcity Media",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1681991209/malik_yqqkaj.png",
      },
      {
        name: "Joshua Okeme",
        title: "COO - Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1681999611/Joshua_Okeme_2023_yj3dbd.jpg",
      },
      {
        name: "Muyiwa Ogundiya",
        title: "Lead Consultant - Starstep Digital",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1681999030/muyiwa_ogundiya_f55yf1.jpg",
      },
    ],
  },
  {
    id: 3,
    title: "Beyond the Buzz: The Current State of Generative AI",
    date: "2023-03-29T20:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680099432/webinar_ygwdet.jpg",
    watchUrl: "https://www.linkedin.com/events/7046492908950061056/",
    speakers: [
      {
        name: "Thomas Bacas",
        title: "Manager AI & Analytics - Legal Data Science",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680099838/Thomas_Bacas_-_Headshot_bqluiv.jpg",
      },
    ],
  },
  {
    id: 4,
    title:
      "[AI] Community Day Q1/23 - The Future of Software Development: AI and Machine Learning at Forefront",
    date: "2023-03-25T10:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002823/Community_Day_Q1_23_HD_j5nssg.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1hlBavHF7_qkZx_87RWAIfbO_F4iFyoF1/view?usp=sharing",
    speakers: [
      {
        name: "Idris Olubisi",
        title: "Developer Relation Engineer and Founder, Web3 Africa",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680003027/Idris_Olubisi_-_Headshot_a0feuz.jpg",
      },
      {
        name: "Khaulat Abdulhakeem",
        title: "Founder, DiverseK | ML Advocate",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680003027/Khaulat_Abdulhakeem_-_Headshot_epumfc.jpg",
      },
      {
        name: "Hussein Sanni",
        title: "Marketing Lead, Studio Creatae",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680003026/Husseni_Sanni_-_Headshot_uihzse.jpg",
      },
    ],
    gallery: [
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002823/Community_Day_Q1_23_HD_j5nssg.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002821/CD_Guest_Speakers_-_Idris_HD_jm2tvx.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002818/CD_Guest_Speakers_-_Khaulat_HD_x89iry.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002818/CD_Guest_Speakers_-_Hussein_HD_m1ptsu.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680007885/AI_COMMUNITY_DAY_32_zgrfuv.jpg",
    ],
  },
  {
    id: 5,
    title:
      "CAREER TRANSITIONING: How [AI] Academy Can Help You Break Into Data Science and AI",
    date: "2023-03-11T19:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002818/Career_Transitioning_Webinar_HD_citv6v.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1M67Uyl3YYDRW_VZE-EF_rDssM3DMzofE/view",
    speakers: [
      {
        name: "Tersoo Ahire",
        title: "[AI] Academy Coordinator",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680003026/Tersoo_Ahire_-_Headshot_maybhf.jpg",
      },
    ],
  },
  {
    id: 6,
    title: "Introduction to Prompt Engineering: Building Skills for the Future",
    date: "2023-02-09T19:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680099118/Prompt_Engineering_Webinar_HD_snk5qc.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1XHaZ8K166iXZlSp6gwkQsfyN3YySEEOG/view?usp=sharing",
    speakers: [
      {
        name: "David Edoja",
        title: "CEO, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362548/David_Edoja2_-_AI_ybv7dm.png",
      },
    ],
  },
  {
    id: 7,
    title: "Basics of Natural Language Processing and Generative AI",
    date: "2023-01-22T19:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680002818/Basics_of_NLP_GAI_Webinar_yjxnyu.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1a7BCUAQ1a64dcYOQWjHP7OpA45Z8EZ1Q/view?usp=sharing",
    speakers: [
      {
        name: "Uwais Iqbal",
        title: "Founder, Simplexico",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1680003026/Uwais_Iqbal_-_Headshot_hqaezr.jpg",
      },
    ],
  },
  {
    id: 8,
    title: "Fundamentals of Machine Learning for Non-Programmers",
    date: "2022-11-27T19:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1670411262/Fundamentals_of_Machine_Learning_Webinar_CORRECTED_HD_ozzuvk.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1Q85mNNvVgAYxmjuRi-xUmp9Zl30jy53V/view?usp=sharing",
    speakers: [
      {
        name: "Jabir Musa",
        title: "Lead data scientist, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362546/WhatsApp_Image_2022-08-09_at_2.25.20_PM_htvzxd.jpg",
      },
    ],
  },
  {
    id: 9,
    title: "Getting Started in Data Storytelling",
    date: "2022-11-13T19:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1667903609/Data_Storytelling_Webinar_HD_d4xlo5.jpg",
    watchUrl:
      "https://drive.google.com/file/d/1nE4_Te2_YKKyUmjy0GMlpSWuA8QqjRCm/view?usp=sharing",
    speakers: [
      {
        name: "David Edoja",
        title: "CEO, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362548/David_Edoja2_-_AI_ybv7dm.png",
      },
    ],
  },
  {
    id: 10,
    title: "[AI] Community Day",
    date: "2022-10-29T08:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1664455176/Community_Day_ga1xgl.jpg",
    watchUrl: "#",
    speakers: [
      {
        name: "David Edoja",
        title: "CEO, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362548/David_Edoja2_-_AI_ybv7dm.png",
      },
      {
        name: "Jabir Musa",
        title: "Lead data scientist, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362546/WhatsApp_Image_2022-08-09_at_2.25.20_PM_htvzxd.jpg",
      },
    ],
    gallery: [
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1664455176/Community_Day_ga1xgl.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1668096177/WhatsApp_Image_2022-11-10_at_8.44.36_AM_sfw3oa.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1668096177/WhatsApp_Image_2022-11-10_at_8.46.46_AM_fbumfz.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1668096176/WhatsApp_Image_2022-11-10_at_8.47.20_AM_ahfku5.jpg",
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1668096175/WhatsApp_Image_2022-11-10_at_8.49.39_AM_lgvbbc.jpg",
    ],
  },
];

export const upcomingEvents = [
  // {
  //   title: "AI Creative Studio: Mastering AI Image, Video & Website Creation",
  //   date: "2026-07-16T00:00:00",
  //   image:
  //     "https://res.cloudinary.com/analytics-intelligence/image/upload/v1784021902/ai-academy/Image_kjtdyi.jpg",
  //   watchUrl:
  //     "https://ai-academy.mykajabi.com/mastering-ai-image-video-website-creation",
  //   speakers: [
  //     {
  //       name: "",
  //       title: " AI/ML Engineer at Punch Group",
  //       avatar:
  //         "https://res.cloudinary.com/analytics-intelligence/image/upload/v1784023762/ai-academy/Image_1_ts67py.jpg",
  //     },
  //   ],
  // },
  {
    title:
      "AI In Action: Building the Future with Data, Intelligence & Innovation",
    date: "2026-10-03T10:00:00",
    image:
      "https://res.cloudinary.com/analytics-intelligence/image/upload/v1790843202/ai-academy/Image_qno5ev.jpg",
    watchUrl:
      "https://ai-academy.mykajabi.com/ai-community-day-2026",
    speakers: [
      {
        name: "David Edoja",
        title: "CEO, [AI] Analytics Intelligence",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1661362548/David_Edoja2_-_AI_ybv7dm.png",
      },
      {
        name: "Oluwasegun Odusina",
        title: " AI/ML Engineer at Punch Group",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1773225384/ai-academy/Image_2_1_hqs5xs.jpg",
      },
      {
        name: "Oluwasegun Odusina",
        title: " AI/ML Engineer at Punch Group",
        avatar:
          "https://res.cloudinary.com/analytics-intelligence/image/upload/v1790844300/ai-academy/Image_1_cnea2v.jpg",
      },
    ],
  },
];
